import React, { useEffect } from 'react'
import ContactPageForm from '../../components/contactPageForm/ContactPageForm'

import styles from '../../styles/pages/Contact.module.scss'

import CustomMetaData from '../../components/general/customMetaData/CustomMetaData'

import { GenericPageLayoutProps } from '../../components/general/genericPageLayout/GenericPageLayout'

import { useGlobalContentContext } from '../../context/GlobalContentContext'
import { parseGenericPage } from '../../utils/parsers'
import { getAPI, createMarkup } from '../../utils/helpers'

type Props = {} & GenericPageLayoutProps

const ContactPage = (props: Props) => {
  const { setData } = useGlobalContentContext()

  useEffect(() => {
    setData(props.globalData)
  }, [props.globalData, setData])

  return (
    <div className={styles.container}>
      <CustomMetaData
        title={props.originalResponse.meta_title}
        description={props.originalResponse.meta_description}
        image={props.originalResponse.meta_image}
      />

      <div className={styles.main}>
        <section className={styles.hero}>
          <div className={styles.heroContentContainer}>
            <h1 className={styles.heroTitle}>{props.originalResponse.title}</h1>

            <div
              className={styles.heroDetail}
              dangerouslySetInnerHTML={createMarkup(
                props.originalResponse.detail
              )}
            ></div>
          </div>
          <ContactPageForm />
        </section>
      </div>
    </div>
  )
}

export async function getStaticProps() {
  const page: GenericPageLayoutProps = await parseGenericPage(
    `${getAPI()}/contactpage/`
  )
  return {
    props: {
      originalResponse: page.originalResponse,
      title: page.title,
      globalData: page.globalData,
      meta_title: page.meta_title,
      meta_description: page.meta_description,
    },
    revalidate: NEXTJS_REVALIDATE_PAGE_IN_SECONDS,
  }
}

export const NEXTJS_REVALIDATE_PAGE_IN_SECONDS = 10
export default ContactPage
